
<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <nb-card [nbSpinner]="loading">
    <nb-card-header>
      <span class="title">
        @if (!isEditing) {
          {{ "Add an energy consumption" | translate }}
        } @else {
          {{ "Edit an energy consumption" | translate }}
        }
      </span>
    </nb-card-header>

    <nb-card-body>
      <div class="form-group">

        <!-- SITE -->
        <div class="form-field">
          <label for="perimeter">{{ 'Site concerned' | translate }}</label>
          <input
            nbInput
            id="site"
            type="text"
            formControlName="site"
            [status]="form.get('site').invalid ? 'danger' : 'basic'"
            >
        </div>

        <!-- BUILDING (PERIMETER) -->
        <div class="form-field">
          <label for="perimeter">{{ 'Building concerned' | translate }}</label>
          <nb-select
            id="perimeter"
            class="perimeter-select"
            formControlName="perimeter"
            [status]="form.get('perimeter').invalid ? 'danger' : 'basic'"
            >
            @for (perimeter of perimeters$ | async; track perimeter) {
              <nb-option [value]="perimeter.id">
                {{ perimeter.name }}
              </nb-option>
            }
          </nb-select>
        </div>

        <!-- ENERGY TYPE -->
        <div class="form-field">
          <label for="perimeter">{{ 'Energy' | translate }}</label>
          <nb-select
            id="energy_type"
            class="energy-type-select"
            formControlName="energy_type"
            [status]="form.get('energy_type').invalid ? 'danger' : 'basic'"
            >
            @for (energyType of energyTypes$ | async; track energyType) {
              <nb-option [value]="energyType.id">
                {{ energyType.name }}
              </nb-option>
            }
          </nb-select>
        </div>

        <!-- YEAR -->
        <div class="form-field">
          <label for="year">{{ 'Year' | translate }}</label>
          <input
            nbInput
            id="year"
            type="number"
            formControlName="year"
            [status]="form.get('year').invalid ? 'danger' : 'basic'"
          >
        </div>

        <!-- CONSUMPTION -->
        <div class="form-field">
          <label for="consumption">
            {{ 'Raw consumption' | translate }} 
            (<span [innerHTML]="'kwh_ef_sub' | translate"></span>)
            @if (isMissingAnyConsumptionError()) { <span class="error">*</span> }
          </label>
          <input
            nbInput
            id="consumption"
            type="number"
            formControlName="consumption"
            [status]="form.get('consumption').invalid ? 'danger' : 'basic'"
          >
        </div>

        <!-- CONSUMPTION CORRECTED CLIMATE -->
        <div class="form-field">
          <label for="consumption_corrected_climate">
            {{ 'Corrected uses and climate' | translate }} 
            (<span [innerHTML]="'kwh_ef_sub' | translate"></span>)
            @if (isMissingAnyConsumptionError()) { <span class="error">*</span> }
          </label>
          <input
            nbInput
            id="consumption_corrected_climate"
            type="number"
            formControlName="consumption_corrected_climate"
            [status]="form.get('consumption_corrected_climate').invalid ? 'danger' : 'basic'"
          >
        </div>

        <!-- CONSUMPTION CORRECTED OFFICIAL -->
        <div class="form-field">
          <label for="consumption_corrected_official">
            {{ 'Corrected official' | translate }} 
            (<span [innerHTML]="'kwh_ef_sub' | translate"></span>)
            @if (isMissingAnyConsumptionError()) { <span class="error">*</span> }
          </label>
          <input
            nbInput
            id="consumption_corrected_official"
            type="number"
            formControlName="consumption_corrected_official"
            [status]="form.get('consumption_corrected_official').invalid ? 'danger' : 'basic'"
          >
        </div>

        <!-- MISSING CONSUMPTION ERROR MESSAGE -->
        @if (isMissingAnyConsumptionError()) {
          <div class="error-message">
            * {{ "Enter at least one of the 3 energy consumptions" | translate }}
          </div>
        }
        
        <!-- COMMENT -->
        <div class="form-field">
          <label for="comment">{{ 'Comment' | translate }}</label>
          <textarea
            nbInput
            id="comment"
            type="number"
            formControlName="comment"
            [status]="form.get('comment').invalid ? 'danger' : 'basic'"
            rows="3"
          ></textarea>
        </div>
      </div>
    </nb-card-body>

    <!-- CANCEL OR SUBMIT -->
    <nb-card-footer class="text-right">
      @if (!loading) {
        <button nbButton type="button" (click)="close()" class="cancel">
          {{ 'pages.decision.spreadsheet.cell-editor-dialog.cancel' | translate }}
        </button>
        <button nbButton type="submit" [disabled]="!form.valid" class="ms-3">
          {{ 'pages.decision.spreadsheet.cell-editor-dialog.confirm' | translate }}
        </button>
      }
    </nb-card-footer>
  </nb-card>
</form>